'use client'

import { ApiPlayground } from '@/components/ui/api-playground'

export default function NotaDebitoPage() {
  const defaultBody = {
    "claveSecreta": "TU_CLAVE_SECRETA",
    "comprobante": {
        "tipoDoc": "08",
        "serie": "FD01",
        "correlativo": "1",
        "codmotivo": "01",
        "descripcion": "INTERES POR MORA",
        "serieRef": "F001",
        "correlativoRef": "1",
        "tipoCompRef": "01",
        "fechaEmision": "2024-01-01",
        "horaEmision": "12:00:00",
        "tipoMoneda": "PEN",
        "tipoPago": "Contado",
        "total": 118,
        "mtoIGV": 18,
        "mtoOperGravadas": 100,
        "totalTexto": "SON CIENTO DIECIOCHO CON 00/100 SOLES"
    },
    "cliente": {
        "tipoDoc": "6",
        "numDoc": "20601234567",
        "rznSocial": "EMPRESA CLIENTE SAC",
        "direccion": "AV. LIMA 123"
    },
    "items": [
        {
            "codProducto": "P001",
            "descripcion": "SERVICIO POR INTERES",
            "unidad": "NIU",
            "cantidad": 1,
            "mtoValorUnitario": 100,
            "mtoPrecioUnitario": 118,
            "igv": 18
        }
    ]
  }

  return (
    <div className="max-w-6xl mx-auto pb-10">
      <ApiPlayground 
        title="Generar XML Nota de Débito"
        description="Crea notas de débito electrónicas para aumentar el valor de facturas y boletas."
        endpoint="https://miapi.cloud/apifact/note/create"
        method="POST"
        defaultBody={defaultBody}
        docType="nota-debito"
      />
    </div>
  )
}
